import React from "react";
import { Row, Col, Image, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "actions";
import { isEmpty } from "lodash";

const Sidebar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const session = useSelector((state) => state.session);

  const userLogout = async (event) => {
    event.preventDefault();
    await dispatch(logout());
  };

  return (
    <div className="sidebar">
      <div className="sidebar-menu-scroll">
        <Link to="/dashboard">
          <Button
            className={`bg-transparent border-0 text-dark font-16 font-weight-medium mb-2 active-sidebar-button ${
              location.pathname === "/dashboard" || location.pathname === "/"
                ? "active-sidebar-menu"
                : ""
            }`}
          >
            <Image src="/assets/images/home-icon.svg" className="me-3 mb-1 " />
            Dashboard
          </Button>
        </Link>
        {!isEmpty(session.user) && session.user.is_super_admin === "y" && (
          <>
            <Link to="/listing">
              <Button
                className={`bg-transparent border-0 text-dark font-16 font-weight-medium mb-2 active-sidebar-button ${
                  location.pathname === "/listing" ? "active-sidebar-menu" : ""
                }`}
              >
                <Image
                  src="/assets/images/user-icon.svg"
                  className="me-2 mb-1 home-icon-application"
                />
                User Manage
              </Button>
            </Link>

            <Link to="/Application">
              <Button
                className={`bg-transparent border-0 text-dark font-16 font-weight-medium mb-2 active-sidebar-button ${
                  location.pathname === "/Application"
                    ? "active-sidebar-menu"
                    : ""
                }`}
              >
                <Image
                  src="/assets/images/add-application.svg"
                  className="me-2 mb-1 home-icon-application"
                />
                Applications
              </Button>
            </Link>

            <Link to="/Timezone">
              <Button
                className={`bg-transparent border-0 text-dark font-16 font-weight-medium mb-2 active-sidebar-button ${
                  location.pathname === "/Timezone" ? "active-sidebar-menu" : ""
                }`}
              >
                <Image
                  src="/assets/images/time-zone-icon.svg"
                  className="me-2 mb-1 home-icon-application"
                  width={24}
                  height={25}
                />
                Timezone
              </Button>
            </Link>
          </>
        )}
      </div>

      <div className="signout-btn">
        <Button
          className="bg-dark border-0 text-white font-16 font-weight-medium w-100 h-48"
          onClick={userLogout}
        >
          <Image src="/assets/images/logout-icon.svg" className="me-2 mb-1" />
          Sign Out
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
